import GroupStore from '../../stores/testEquipment/GroupTypeStore';
import KindTypeStore from '../../stores/testEquipment/KindTypeStore';
import TimeUnitStore from '../../stores/testEquipment/TimeUnitStore';
import PlaceOfUseTypeStore from '../../stores/testEquipment/PlaceOfUseTypeStore';
import { RiskOptionSetting } from './archivemodal/archivemodal.model';
import MeasurementSpecificationTemplatesStore from '../../stores/testEquipment/MeasurementSpecificationTemplatesStore';

export default class State {
  readonly groupsStore = new GroupStore();
  readonly kindsStore = new KindTypeStore();
  readonly timeUnitsStore = new TimeUnitStore();
  readonly placeOfUsesStore = new PlaceOfUseTypeStore();
  readonly templatesStore = new MeasurementSpecificationTemplatesStore();
  riskOptionsSetting: RiskOptionSetting = { en: [], de: [] };
}